import React, { useEffect, useRef, useContext, useState } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { ListItem, Divider, makeStyles } from '@material-ui/core';
import { defineMessages, useIntl } from 'react-intl';
import { FormContext } from './form';
import { useFormStyles } from './formFields'; 
import { activityUseStyles } from './activityFormField';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { isImage } from '../common/attachments/attachmentsHelper';

const messages = defineMessages({
    additionalDetails: {
        id: 'task-complete-form.attachment-additional-details',
        defaultMessage: 'Additional details',
        description: 'Additional details'
    },
});

const useStyles = makeStyles((theme) => ({
    detailsParent: {
        textAlign: 'left',
        display: 'flex',
        padding: 0,
        width: '100%',
        margin: 'auto'
    },
    details: {
        paddingRight: '12px',
        color: "#999999",
    },
    detailsWithVal: {
        color: "#555555"
    },
    editIcon: {
        margin: 'auto 0 auto'
    },
    thumbnail: {
        height: '50px',
        width: '50px', 
        borderRadius: '4px'
    },
    imgContainer: {
        padding: '0px 5px',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    fileName: {
        '&:hover': {
            cursor: 'pointer'
        }
    }
}));

export const AttachmentEntry = (props) => {
    const formServices = useContext(FormContext);
    const { file } = props;
    const intl = useIntl();
    const [valueDetails, setValueDetails] = useState(file.fileDescription); // Replace with retrieved description eventually
    const [value, setValue] = useState(file.fileDescription); // Value to actually display after clicking "done"
    const classes = Object.assign(useStyles(), activityUseStyles(), useFormStyles());

    const onChange = (event) => { 
        const val = event.target.value
        setValueDetails(val)
    }

    const onDetailsEntered = (event) => {
        setValue(valueDetails);
    }

    const imageDetails = () => {
        return <div className={classes.detailsParent}>
            <span className={clsx({ [classes.details]: !value, [classes.detailsWithVal]: value})}>
                {value ? value : intl.formatMessage(messages.additionalDetails)}
            </span>
            <span style={{margin: 'auto'}}>
                <EditIcon style={{marginTop: '-8px'}} color="primary" />
            </span>
        </div>
    }

    return (  
        <>   
            <ListItem>       
                <div 
                    className={classes.formElement}
                >
                    <div className={classes.imgContainer} onClick={props.handleAttachmentSelect}>
                        {isImage(file.fileType) && (
                            <img 
                                className={classes.thumbnail}
                                src={`data:${file.fileType};base64,${file.data}`} 
                            />)
                        }
                    </div>
                    <div className={classes.formInfo}>
                        <div className={clsx(classes.infoHeader, classes.fileName)} onClick={props.handleAttachmentSelect}>
                            {file.fileName}
                        </div>
                        <div className={classes.formResult}>
                            { // Shouldn't be able to add a description to an existing file as labourer at 
                            // this point in the flow, doesn't really make sense
                            /*props.editorProps && formServices.edit({
                                ...props.editorProps,
                                icon: imageDetails(),
                                value: valueDetails,
                                activity: true, // Need to use the activity styling
                                onChange,
                                btnCallback: onDetailsEntered,
                                characterCount: props.characterCountEnabled ? (valueDetails ? valueDetails.length : '0') : null
                            })*/}
                        {valueDetails ? <div className={classes.valueDetails}>{valueDetails}</div> : ''}
                        </div>
                    </div>
                    {/* Hiding the remove button because labourer might not be meant to delete? TBA
                        <div className={classes.formQtyDelete}>
                        <DeleteIcon 
                            color="primary"
                            className={classes.formDelete}
                            onClick={props.onRemove}
                        />
                        </div>*/}
                </div>
            </ListItem>
            <Divider />
        </>
    )
}

const mapStateToProps = (state, prevProps) => {
    return ({
        workOrderAttachments: state.attachments.workOrderAttachments,
    })
};

export default connect(mapStateToProps)(AttachmentEntry);